import type React from 'react'
import type { ChangeEvent, JSX, Ref } from 'react'
import type { IconNames } from 'atoms/Icon'
import type { ITextBoxProps } from 'atoms/TextBox'

import { Icon, IconSizes } from 'atoms/Icon'
import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { COLOR } from 'vars/index'
import { Background, BorderColors, Color } from './RadioButton.h'
import { Checkmark, Label } from './RadioButton.styled'

export interface IRadioProps {
  ref?: Ref<HTMLLabelElement>
  id: string
  name?: string
  value?: string | number
  selectedValue?: string | number
  title?: ITextBoxProps['title']
  font?: ITextBoxProps['font']
  borderColor?: BorderColors
  borderColorHovered?: BorderColors
  borderColorChecked?: BorderColors
  borderColorDisabled?: BorderColors
  background?: Background
  backgroundHovered?: Background
  color?: Color
  colorDisabled?: Color
  backgroundChecked?: Background
  backgroundDisabled?: Background
  checked?: boolean
  defaultChecked?: boolean
  disabled?: boolean
  className?: string
  icon?: IconNames
  onClick?: (event: React.MouseEvent) => void
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

export function Radio({
  ref,
  id,
  title = '',
  font = TextBoxTypes.Button1,
  name = 'radio',
  value,
  selectedValue,
  background = Background.SURFACE_OPACITY_LIGHT_10,
  color = Color.TEXT_IN_BUTTON_PRIMARY,
  colorDisabled = Color.SURFACE_OPACITY_LIGHT_10,
  // backgroundHovered = Background.SURFACE_OPACITY_LIGHT_10,
  backgroundChecked = Background.ACCENT_PRIMARY_GRADIENT,
  backgroundDisabled = Background.DISABLED,
  borderColor = BorderColors.TEXT_ICON_SECONDARY,
  borderColorHovered = BorderColors.ACCENT_SECONDARY,
  borderColorChecked = BorderColors.ACCENT_SECONDARY,
  borderColorDisabled = BorderColors.SURFACE_OPACITY_LIGHT_10,
  checked,
  defaultChecked,
  disabled = false,
  className = '',
  icon,
  onClick,
  onChange,
}: IRadioProps): JSX.Element {
  return (
    <Label
      ref={ref}
      htmlFor={id}
      className={className}
      colorDisabled={colorDisabled}
      borderColorHovered={borderColorHovered}
      borderColorChecked={borderColorChecked}
      borderColorDisabled={borderColorDisabled}
      backgroundChecked={backgroundChecked}
      backgroundDisabled={backgroundDisabled}
      onClick={onClick}
    >
      {title && (
        <TextBox
          title={title}
          font={font}
          color={TextBoxColors.TEXT_ICON_PRIMARY}
          maxLines={1}
        />
      )}
      <input
        type='radio'
        id={id}
        name={name}
        readOnly
        value={value}
        checked={checked ?? value === selectedValue}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={onChange}
      />
      <Checkmark
        background={background}
        colorDefault={color}
        borderColor={borderColor}
      >
        {icon && (
          <Icon
            name={icon}
            size={IconSizes.small}
            color={
              disabled
                ? COLOR.SURFACE_OPACITY_LIGHT_10
                : COLOR.TEXT_ICON_CONSTANT_LIGHT
            }
          />
        )}
      </Checkmark>
    </Label>
  )
}
